import {OperatorSignatureField} from '@/features/projects/components/project-form/opertor-signature-field/OperatorSignatureField'
import {PrintSiarFormSchema} from '@/features/projects/formSchemas'
import {useController, useFormContext} from 'react-hook-form'
import {z} from 'zod'

const PrintSiarOperatorSignatureFieldSchema = PrintSiarFormSchema.pick({
    hasSignature: true
})
type PrintSiarOperatorSignatureFieldSchema = z.infer<typeof PrintSiarOperatorSignatureFieldSchema>

export const PrintSiarOperatorSignatureField = () => {
    const {control} = useFormContext<PrintSiarOperatorSignatureFieldSchema>()
    const {field: hasSignatureField} = useController({control, name: 'hasSignature'})
    return <OperatorSignatureField isSigned={hasSignatureField.value} setIsSigned={hasSignatureField.onChange} />
}
